import { StateCreator } from 'zustand';
import {
  IKioskInstitutionFields,
  IKioskInstitutionSlice,
  TKioskStore,
} from './type';
import { institutionsApi } from '@/API';
import { convertKeys } from '@/utils/common';
import { TInstitutionServerCamel } from '@/types';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

const initState: IKioskInstitutionFields = {
  kioskInstitution: null,
};

export const kioskInstitutionSlice: StateCreator<
  TKioskStore,
  [],
  [],
  IKioskInstitutionSlice
> = (set, get) => ({
  ...initState,
  setKioskInstitution: (kioskInstitution) => {
    set({ kioskInstitution });
  },
  getKioskInstitution: async () => {
    try {
      const response = await institutionsApi.getKioskInstitutions();
      const kioskId = localStorage.getItem(LOCAL_STORAGE_KEYS.KIOSK_ID);
      // The backend sends only one institution to which the kiosk is linked.
      const kioskInstitution: TInstitutionServerCamel = convertKeys(
        response.data.data[0],
      );
      const kioskData = kioskInstitution.kiosks?.find(
        ({ id }) => id === kioskId,
      );
      set({ kioskInstitution, kioskData });
      return kioskInstitution;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  updateKioskTimezone: async (timezone) => {
    const { kioskInstitution, kioskData, setKioskData, setKioskInstitution } =
      get();
    if (!kioskInstitution?.id || !kioskData?.id) {
      throw new Error('Kiosk institution or kiosk data not found');
    }

    try {
      const kioskPayload = {
        kiosks: [
          {
            ...kioskData,
            timezone,
          },
        ],
      };

      const response = await institutionsApi.patchKioskInstitution(
        kioskInstitution.id,
        convertKeys(kioskPayload, 'snake'),
      );

      const updatedKioskInstitution = convertKeys(response.data.data);
      const updatedKioskData =
        updatedKioskInstitution.kiosks?.find(({ id }) => id === kioskData.id) ??
        null;

      setKioskInstitution(updatedKioskInstitution);
      setKioskData(updatedKioskData);
    } catch (err) {
      console.error('Failed to update kiosk timezone:', err);
      throw err;
    }
  },
});
